export var defaultToggleBoxProps = {
  connected: false,
  direction: 'horizontal',
  layout: 'inline',
  size: 'medium'
};